export const hasExistingDetailId = (id) =>
  id !== null && id !== undefined && id !== "";

export const toDetailProyekPayloadItem = (row, index) => ({
  id: row.id,
  no: index + 1,
  tglDpDate: row.tglDpDate ? row.tglDpDate.toISOString() : null,
  noRab: row.noRab,
  pekerjaan: row.pekerjaan,
  pekerjaanChild: row.pekerjaanChild,
  ukuran: Number(row.ukuran) || null,
  satuan: row.satuan,
  keterangan: row.keterangan,
  kirimGambar: Number(row.kirimGambar) || null,
  kirimGambarDate: row.kirimGambarDate
    ? row.kirimGambarDate.toISOString()
    : null,
  kirimGambarMenunggu: row.kirimGambarMenunggu,
  revisi: row.revisi,
  revisiDate: row.revisiDate ? row.revisiDate.toISOString() : null,
  revisiNotes: row.revisiNotes,
  revisiMenunggu: row.revisiMenunggu,
  po: row.po,
  poDate: row.poDate ? row.poDate.toISOString() : null,
  poNotes: row.poNotes,
  poMenunggu: row.poMenunggu,
  masukProduksi: row.masukProduksi,
  masukProduksiDate: row.masukProduksiDate
    ? row.masukProduksiDate.toISOString()
    : null,
  masukProduksiMenunggu: row.masukProduksiMenunggu,
  produksi: row.produksi,
  produksiDate: row.produksiDate ? row.produksiDate.toISOString() : null,
  produksiMenunggu: row.produksiMenunggu,
});

export const buildDetailProyekDeltaPayload = ({
  spreadsheetRows,
  dirtyDetailProyekIds,
  deletedDetailProyekIds,
  spreadsheetProyekId,
  kodeProyek,
  tanggalProyekDate,
}) => {
  const updatedItems = spreadsheetRows
    .map((row, index) => ({ row, index }))
    .filter(
      ({ row }) =>
        hasExistingDetailId(row.id) && dirtyDetailProyekIds.includes(row.id),
    )
    .map(({ row, index }) => toDetailProyekPayloadItem(row, index));

  const newItems = spreadsheetRows
    .map((row, index) => ({ row, index }))
    .filter(({ row }) => !hasExistingDetailId(row.id))
    .map(({ row, index }) => toDetailProyekPayloadItem(row, index));

  const order = spreadsheetRows
    .map((row, index) => ({ id: row.id, no: index + 1 }))
    .filter((row) => hasExistingDetailId(row.id));

  return {
    proyekId: spreadsheetProyekId,
    kodeProyek,
    tanggalProyek: tanggalProyekDate ? tanggalProyekDate.toISOString() : null,
    updatedItems,
    newItems,
    deletedIds: deletedDetailProyekIds,
    order,
  };
};
